/* Auto-scroll to the #anchor in the URL on page load.

   The browser's own hash jump happens before the page has settled, so it can
   land short: images and app blocks above the target are still resolving their
   heights. Redoing the jump on `load` puts it in the right place.

   The hash is read once here, during script evaluation, rather than read again
   later - product-variants.js and facets.js both call replaceState with a URL
   built from pathname + search, which drops the fragment.

   No offset maths: scrollIntoView() honours scroll-padding-block-start, which
   base.css already sets on html. */
;(function () {
  var initialHash = window.location.hash
  if (!initialHash) return

  var targetId
  try {
    targetId = decodeURIComponent(initialHash.slice(1))
  } catch (error) {
    targetId = initialHash.slice(1) // malformed percent-encoding, use it raw
  }

  /* Canonical anchors, so a deep link does not have to know which grid a
     template renders. Collection templates using the theme grid carry
     #collection-products themselves (sections/main-collection.liquid). Where
     Fast Simon owns the grid the theme cannot add an id, so map onto the
     container its app block server-renders. Both are in the initial HTML, so
     the target is always present by `load`. */
  var ANCHOR_ALIASES = {
    "collection-products": ["fast-simon-serp-app"]
  }

  var findTarget = function () {
    var target = document.getElementById(targetId)
    if (target) return target

    var aliases = ANCHOR_ALIASES[targetId] || []
    for (var i = 0; i < aliases.length; i++) {
      target = document.getElementById(aliases[i])
      if (target) return target
    }
    return null
  }

  // If the visitor starts scrolling before load, leave them where they are.
  var repositionAllowed = true
  var takeOver = function () {
    repositionAllowed = false
  }
  var takeOverEvents = ["wheel", "touchstart", "pointerdown", "keydown"]
  takeOverEvents.forEach(function (name) {
    window.addEventListener(name, takeOver, { passive: true, once: true })
  })

  /* Animated, not an instant jump - this is the behaviour the theme shipped
     with originally. Respect a reduced-motion preference, as base.css does. */
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches

  window.addEventListener("load", function () {
    if (!repositionAllowed) return
    var target = findTarget()
    if (!target) return
    target.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "start"
    })
  })
})()
